import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
/**
 * Get the list of available file sources from the server that can be browsed.
 * @param options The options to filter the file sources.
 * @returns The list of available (browsable) file sources from the server.
 */
export async function fetchFileSources(options = {}) {
    const { data, error } = await GalaxyApi().GET("/api/remote_files/plugins", {
        params: {
            query: {
                browsable_only: true,
                include_kind: options.include,
                exclude_kind: options.exclude,
            },
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    // Since we specified browsable_only in the query, we can safely cast the data to the expected type.
    return data;
}
/**
 * Get the list of files and directories from the server for the given file source URI.
 * @param uri The file source URI to browse.
 * @param isRecursive Whether to recursively retrieve all files inside subdirectories.
 * @param writeable Whether to return only entries that can be written to.
 * @param limit The maximum number of entries to return.
 * @param offset The number of entries to skip before returning the rest.
 * @param query The query string to filter the entries.
 * @param sortBy The field to sort the entries by.
 * @returns The list of files and directories from the server for the given URI.
 */
export async function browseRemoteFiles(uri, isRecursive = false, writeable = false, limit, offset, query, sortBy) {
    const { response, data, error } = await GalaxyApi().GET("/api/remote_files", {
        params: {
            query: {
                format: "uri",
                target: uri,
                recursive: false,
                writeable,
                limit,
                offset,
                query,
                sort_by: sortBy,
            },
        },
    });
    if (error) {
        rethrowSimple(error);
    }
    const totalMatches = parseInt(response.headers.get("total_matches") ?? "0");
    // Since we specified format=uri in the query, we can safely cast the data to the expected type.
    const entries = data;
    return { entries, totalMatches };
}
